/* @flow */

import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import ProductOutline from './product-outline-icon.svg';

function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <ProductOutline {...validProps} />;
}
SvgComponent.iconName = 'productOutline';

export const ProductOutlineIcon = svgIconWrapper(SvgComponent);
